import { createStore } from "vuex";
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
export default createStore({
  state: {
    projects: []
  },
  mutations: {
    setProjects(state, projects) {
      state.projects = projects;
    }
  },
  actions: {
    async getProjects(context) {
      const response = await firebase
        .firestore()
        .collection("projects")
        .get();

      const retrievedProjects = [];
      response.forEach(doc => {
        const project = doc.data();
        project.id = doc.id;
        retrievedProjects.push(project);
      });
      context.commit("setProjects", retrievedProjects);
    },
    async getProjectById(_context, projectId) {
      const docRef = await firebase
        .firestore()
        .collection("projects")
        .doc(projectId);

      const project = await docRef.get();
      return project.data();
    },
    async saveProject(_contex, projectData) {
      const response = await firebase
        .firestore()
        .collection("projects")
        .add(projectData);

      return response.id;
    },
    async saveClient(_context, clientData) {
      const response = await firebase
        .firestore()
        .collection("clients")
        .add(clientData);
      return response.id;
    },
    async getClientById(_context, clientId) {
      const docRef = await firebase
        .firestore()
        .collection("clients")
        .doc(clientId);

      const client = await docRef.get();
      return client.data();
    },
    async updateProject(_context, payload) {
      const projectRef = firebase
        .firestore()
        .collection("projects")
        .doc(payload.projectId);
      await projectRef.update(payload.updateData);
    },
    async updateClient(_context, payload) {
      const clientRef = firebase
        .firestore()
        .collection("clients")
        .doc(payload.clientId);
      await clientRef.update(payload.updateData);
    },
    async uploadImage(_context, payload) {
      const result = await firebase
        .storage()
        .ref()
        .child(`${payload.path}/${payload.image.name}`)
        .put(payload.image);
      return result;
    },
    async deleteStorageItem(_context, fullPath) {
      const result = await firebase
        .storage()
        .ref()
        .child(fullPath)
        .delete();
      return result;
    },
    async getDefaultCoverImage() {
      const storageRef = firebase.storage().ref();

      const imgsList = await storageRef.child("default_images").list();
      const imgNum = imgsList.items.length;
      const randomIndex = Math.floor(Math.random() * imgNum);
      const imgPath = imgsList.items[randomIndex].fullPath;
      const url = await storageRef.child(imgPath).getDownloadURL();
      return url;
    },
    async listProjectImages(_context, path) {
      const storageRef = firebase.storage().ref();
      const listRef = storageRef.child(path);
      const list = await listRef.list();
      return list;
    },
    async listProjectFolders(_context, path) {
      const storageRef = firebase.storage().ref();
      const listRef = storageRef.child(path);
      const list = await listRef.list();
      return list;
    },

    async getImgDownloadUrl(_context, fullPath) {
      const storageRef = firebase.storage().ref();
      const downloadUrl = await storageRef.child(fullPath).getDownloadURL();
      return downloadUrl;
    }
  },
  getters: {
    projects(state) {
      return state.projects;
    }
  }
});
